import type { BillingPrice, WorkspaceBilling } from '@floorpoll/shared';
import { apiRequest } from './api.js';

/** What `GET /workspaces/{id}/billing` returns — see handlers/app/billing.ts. */
export interface BillingView {
  pro: boolean;
  /** False when the environment has no Stripe secret; the panel hides itself. */
  configured: boolean;
  /**
   * Exactly the fields that endpoint returns, picked from the stored record
   * rather than hand-copied from it. The hand-copy drifted the moment a third
   * `source` existed, and silently: nothing relates the two declarations, so
   * the console went on asserting a value the API was already sending. Picking
   * makes the next component a compile error here — in `PlanCard`, the one
   * place that must handle it — instead of a wrong plan on someone's account.
   */
  billing?: Pick<
    WorkspaceBilling,
    'proUntil' | 'renewsAt' | 'source' | 'subscriptionStatus' | 'cancelAtPeriodEnd'
  >;
}

export const getBilling = (workspaceId: string) =>
  apiRequest<BillingView>(`/workspaces/${workspaceId}/billing`);

/** Returns the Stripe-hosted Checkout URL; the caller navigates to it. */
export const startCheckout = (workspaceId: string, price: BillingPrice) =>
  apiRequest<{ url: string }>(`/workspaces/${workspaceId}/billing/checkout`, {
    method: 'POST',
    body: { price },
  });

/** Returns the Stripe-hosted Customer Portal URL; the caller navigates to it. */
export const openPortal = (workspaceId: string) =>
  apiRequest<{ url: string }>(`/workspaces/${workspaceId}/billing/portal`, { method: 'POST' });
